import React from 'react';

const Icon = ({ width = '45', height = '46', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 45 46" fill="none" {...other}>
            <g clipPath="url(#a)">
                <path
                    d="M31.311 4.902h-18.09a2.087 2.087 0 0 0-2.088 2.088v32.007c0 1.153.934 2.088 2.087 2.088h18.091a2.087 2.087 0 0 0 2.088-2.088V6.99a2.087 2.087 0 0 0-2.088-2.088ZM19.483 9.078h5.566"
                    stroke="black"
                    strokeWidth="2.087"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />

                <path d="M24.354 36.212a2.087 2.087 0 1 1-4.175 0 2.087 2.087 0 0 1 4.175 0Z" fill="black" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="white" d="M0 .727h44.532v44.532H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
